import React, { Component } from 'react'
import Footer from './footer'
import './main.css'
import Back from './back'
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied'

class NotFound extends Component {

	render() {
		return (
			<div>
				<div className='notfound'>
					<Back items={[{ label: 'Página não encontrada' }]} title="Página não encontrada" />
					<div className="notfound-message">
						<SentimentDissatisfiedIcon className="notfound-icon" />
						<p className="notfound-text">Página não encontrada.</p>
						<p className="notfound-subtext">A página que você procura não existe ou foi movida.</p>
					</div>
				</div>
			</div>
		);
	}
}

export default NotFound;
